export const Images = {
  dashboard: require("../asset/images/dashboard.png"),
  dashboardActive: require("../asset/images/dashboardActive1.png"),
  logo: require("../asset/images/logo.png"),
  salesImg: require("../asset/images/cardImg.svg").default,
  globe: require("../asset/images/global.svg").default,
  twitter: require("../asset/images/twitter.svg").default,
  telegram: require("../asset/images/telegram.svg").default,
  cat: require("../asset/images/cat.png"),
  triangle: require("../asset/images/triangle.png"),
  rightmark: require("../asset/images/rightmark.png"),
  lighting: require("../asset/images/lighting.png"),
  clip: require("../asset/images/clip.png"),
  solmax: require("../asset/images/solmax.png"),
  solmax1: require("../asset/images/solmax2.png"),
  bannerclif: require("../asset/images/bannerclif.png"),
  buttonNext: require("../asset/images/buttonNext.png"),
  itachiBanner: require('../asset/images/itachiBanner.jpg'),
  itachiLogo: require('../asset/images/itachiLogo.jpg'),
  goldIndi: require("../asset/images/goldIndi.svg").default,
  Flash: require('../asset/images/Flash.png'),
  redCat: require("../asset/images/redCat.svg").default,
  coinCat: require('../asset/images/coinCat.png'),
  endFlash: require('../asset/images/endFlash.png'),
  solana: require('../asset/images/solana.png'),
  noData: require('../asset/images/nodata.png'),
  walletConnect: require("../asset/images/walletconnect.svg").default,
  hamburger: require("../asset/images/hamburger.svg").default,
  admin_launchpad: require("../asset/images/admin_launchpad.svg").default,
  admin_createLaunchpad: require("../asset/images/admin_createLaunchpad.svg").default,
  admin_fairlaunch: require("../asset/images/admin_fairlaunch.svg").default,
  admin_privatesale: require("../asset/images/admin_privatesale.svg").default,
  admin_kyc: require("../asset/images/admin_kyc.svg").default,
  admin_settings: require("../asset/images/admin_settings.svg").default,
  admin_launchSettins: require("../asset/images/admin_launchSettins.svg").default,
  admin_audit: require("../asset/images/admin_audit.svg").default,
  admin_profileSettings: require("../asset/images/admin_profileSettings.svg").default,
  admin_feeSettings: require("../asset/images/admin_feeSettings.svg").default,
  admin_launchpadList: require("../asset/images/admin_launchpadList.svg").default,
  admin_cms: require("../asset/images/admin_cms.svg").default,
  document: require("../asset/images/document.svg").default,

  // nexus images

  // homeHandImg: require("../asset/images/nexus/handImgLightTheme.png"),
  // tokenChartImg: require("../asset/images/nexus/homeChart1Img.png"),
  // netWorkChart: require("../asset/images/nexus/homeChart2Img.png"),
  // footerNexusLogo: require("../asset/images/nexus/footerNexusLogo.png"),

  coinSpinImg: require("../asset/images/nexus/coinSpinImg.png"),
  coinspinGif: require("../asset/images/nexus/coinspinGif.gif"),
  twitterIcon: require("../asset/images/nexus/twitterIcon.png"),
  telegramIcon: require("../asset/images/nexus/telegramIcon.png"),
  facebookIcon: require("../asset/images/nexus/facebookIcon.png"),
  discordIcon: require("../asset/images/nexus/discordIcon.png"),
  sunIcon: require("../asset/images/nexus/sunIcon.png"),
  moonIcon: require("../asset/images/nexus/moonIcon.png"),

  sliderHotImg: require("../asset/images/nexus/slider_hotImg.png"),
  sliderImg1: require("../asset/images/nexus/sliderImg1.png"),
  sliderImg2: require("../asset/images/nexus/sliderImg2.png"),
  sliderImg3: require("../asset/images/nexus/sliderImg3.png"),
  sliderImg4: require("../asset/images/nexus/sliderImg4.png"),
  sliderImg5: require("../asset/images/nexus/sliderImg5.png"),
  sliderImg6: require("../asset/images/nexus/sliderImg6.png"),
  sliderImg7: require("../asset/images/nexus/sliderImg7.png"),
  sliderImg8: require("../asset/images/nexus/sliderImg8.png"),

  // cardBgImg: require("../asset/images/nexus/cardBgImg.png"),
  cardBgImg: require("../asset/images/nexus/cardBgImg3.png"),
  cardBgImg2: require("../asset/images/nexus/cardBgImg2.png"),
  cardCoinImg: require("../asset/images/nexus/cardCoinImg.png"),
  cardSymbolImg: require("../asset/images/nexus/cardSymbolImg.png"),
  diamentImg: require("../asset/images/nexus/diamentImg.png"),

  tokenomicsIcon1: require("../asset/images/nexus/tokenomicsIcon1.png"),
  tokenomicsIcon2: require("../asset/images/nexus/tokenomicsIcon2.png"),
  tokenomicsIcon3: require("../asset/images/nexus/tokenomicsIcon3.png"),
  tokenomicsIcon4: require("../asset/images/nexus/tokenomicsIcon4.png"),
  tokenomicsIcon5: require("../asset/images/nexus/tokenomicsIcon5.png"),
  tokenomicsIcon6: require("../asset/images/nexus/tokenomicsIcon6.png"),
  pointMarkIcon: require("../asset/images/nexus/pointMarkIcon.png"),

  nexusTokenIcon1: require("../asset/images/nexus/nexusTokenIcon1.png"),
  nexusTokenIcon2: require("../asset/images/nexus/nexusTokenIcon2.png"),
  nexusTokenIcon3: require("../asset/images/nexus/nexusTokenIcon3.png"),
  nexusTokenIcon4: require("../asset/images/nexus/nexusTokenIcon4.png"),
  nexusTokenCenterLogo: require("../asset/images/nexus/nexusTokenCenterLogo.png"),

  dark_applyListIcon1: require("../asset/images/nexus/dark_applyListIcon1.png"),
  dark_applyListIcon2: require("../asset/images/nexus/dark_applyListIcon2.png"),
  dark_applyListIcon3: require("../asset/images/nexus/dark_applyListIcon3.png"),
  dark_applyListIcon4: require("../asset/images/nexus/dark_applyListIcon4.png"),
  dark_applyListIcon5: require("../asset/images/nexus/dark_applyListIcon5.png"),

  light_applyListIcon1: require("../asset/images/nexus/light_applyListIcon1.png"),
  light_applyListIcon2: require("../asset/images/nexus/light_applyListIcon2.png"),
  light_applyListIcon3: require("../asset/images/nexus/light_applyListIcon3.png"),
  light_applyListIcon4: require("../asset/images/nexus/light_applyListIcon4.png"),
  light_applyListIcon5: require("../asset/images/nexus/light_applyListIcon5.png"),

  whyNexuIcon1: require("../asset/images/nexus/whyNexuIcon1.png"),
  whyNexuIcon2: require("../asset/images/nexus/whyNexuIcon2.png"),
  whyNexuIcon3: require("../asset/images/nexus/whyNexuIcon3.png"),
  rocketImg: require("../asset/images/nexus/rocketImg.png"),

  rubix_whyImg: require("../asset/images/nexus/rubix_whyImg.png"),
  uniqueImgGif: require("../asset/images/nexus/uniqueImg.gif"),

  liveTokenSalesChart: require("../asset/images/nexus/liveTokenSalesChart.png"),
  liveTokenImg: require("../asset/images/nexus/liveTokenImg.png"),

  aboutRubixImg: require("../asset/images/nexus/aboutRubixImg.png"),
  rubixWorldImg: require("../asset/images/nexus/rubixWorld.png"),

  rubixCenterLogo: require("../asset/images/nexus/rubixCenterLogo.png"),
  rubixTokenIcon1: require("../asset/images/nexus/rubixTokenIcon1.png"),
  rubixTokenIcon2: require("../asset/images/nexus/rubixTokenIcon2.png"),

  liquidityRewardsChartImg: require("../asset/images/nexus/liquidityRewardsChartImg.png"),

  rubixLaunchpadIcon1: require("../asset/images/nexus/rubixLaunchpadIcon1.png"),
  rubixLaunchpadIcon2: require("../asset/images/nexus/rubixLaunchpadIcon2.png"),
  rubixLaunchpadIcon3: require("../asset/images/nexus/rubixLaunchpadIcon3.png"),
  rubixLaunchpadIcon4: require("../asset/images/nexus/rubixLaunchpadIcon4.png"),
  rubixLaunchpadIcon5: require("../asset/images/nexus/rubixLaunchpadIcon5.png"),

  downArrowIcon: require("../asset/images/nexus/downArrowIcon.png"),
  dark_footerNexusLogo: require("../asset/images/nexus/footerDarkThemeNexusLogo.png"),
  light_footerNexusLogo: require("../asset/images/nexus/footerLightThemeNexusLogo.png"),
  // patten Images 
  // banner section
  circleShapeImg1: require("../asset/images/nexus/circleShapeImg1.png"),
  circleShapeImg2: require("../asset/images/nexus/circleShapeImg2.png"),
  circleShapeImg3: require("../asset/images/nexus/circleShapeImg3.png"),
  circleShapeImg4: require("../asset/images/nexus/circleShapeImg4.png"),
  circleShapeImg5: require("../asset/images/nexus/circleShapeImg5.png"),
  circleShapeImg6: require("../asset/images/nexus/circleShapeImg6.png"),
  circleShapeImg7: require("../asset/images/nexus/circleShapeImg7.png"),
  homeBannerBottomImg: require("../asset/images/nexus/homeBannerBottomImg.png"),
  // launchpad section
  circleShapeImg8: require("../asset/images/nexus/circleShapeImg8.png"),
  circleShapeImg9: require("../asset/images/nexus/circleShapeImg9.png"),
  circleShapeImg10: require("../asset/images/nexus/circleShapeImg10.png"),
  circleShapeImg11: require("../asset/images/nexus/circleShapeImg11.png"),
  circleShapeImg12: require("../asset/images/nexus/circleShapeImg12.png"),
  circleShapeImg13: require("../asset/images/nexus/circleShapeImg13.png"),
  circleShapeImg14: require("../asset/images/nexus/circleShapeImg14.png"),
  circleShapeImg15: require("../asset/images/nexus/circleShapeImg15.png"),
  circleShapeImg16: require("../asset/images/nexus/circleShapeImg16.png"),
  circleShapeImg17: require("../asset/images/nexus/circleShapeImg17.png"),
  circleShapeImg18: require("../asset/images/nexus/circleShapeImg18.png"),
  threeLineImg: require("../asset/images/nexus/threeLineImg.png"),
  leftThreeLine: require("../asset/images/nexus/leftThreeLine.png"),
  circleShapeImg19: require("../asset/images/nexus/circleShapeImg19.png"),
  circleShapeImg20: require("../asset/images/nexus/circleShapeImg20.png"),

  // launchPadPage
  launchpadCircle1Icon: require("../asset/images/nexus/launchpadCircle1Icon.png"),
  launchpadCircle2Icon: require("../asset/images/nexus/launchpadCircle2Icon.png"),
  launchpadCircle3Icon: require("../asset/images/nexus/launchpadCircle3Icon.png"),
  launchpadCircle4Icon: require("../asset/images/nexus/launchpadCircle4Icon.png"),
  launchpadCircle5Icon: require("../asset/images/nexus/launchpadCircle5Icon.png"),
  launchpadCircle6Icon: require("../asset/images/nexus/launchpadCircle6Icon.png"),
  launchpadCircle7Icon: require("../asset/images/nexus/launchpadCircle7Icon.png"),
  launchpadCircle8Icon: require("../asset/images/nexus/launchpadCircle8Icon.png"),
  // explorePage
  exploreCircle1Icon: require("../asset/images/nexus/exploreCircle1Icon.png"),
  exploreCircle2Icon: require("../asset/images/nexus/exploreCircle2Icon.png"),
  exploreCircle3Icon: require("../asset/images/nexus/exploreCircle3Icon.png"),
  exploreCircle4Icon: require("../asset/images/nexus/exploreCircle4Icon.png"),
  exploreCircle5Icon: require("../asset/images/nexus/exploreCircle5Icon.png"),

  darkThemeCoinImg: require("../asset/images/nexus/darkThemeCoinImg.png"),
  lightThemeCoinImg: require("../asset/images/nexus/lightThemeCoinImg.png"),

  lineImg: require("../asset/images/nexus/LineImg.png"),

  // dao Page patten
  daoPattenImg1: require("../asset/images/nexus/daoPattenImg1.png"),
  daoPattenImg2: require("../asset/images/nexus/daoPattenImg2.png"),
  daoPattenImg3: require("../asset/images/nexus/daoPattenImg3.png"),
  daoPattenImg4: require("../asset/images/nexus/daoPattenImg4.png"),
  daoPattenImg5: require("../asset/images/nexus/daoPattenImg5.png"),

  // ai page patten
  aiPattenImg1: require("../asset/images/nexus/aiPattenImg1.png"),
  aiPattenImg2: require("../asset/images/nexus/aiPattenImg2.png"),
  aiPattenImg3: require("../asset/images/nexus/aiPattenImg3.png"),
  aiPattenImg4: require("../asset/images/nexus/aiPattenImg4.png"),
  aiPattenImg5: require("../asset/images/nexus/aiPattenImg5.png"),

  // nexusTokenPatten
  nexusTokenPatten1: require("../asset/images/nexus/nexusTokenPatten1.png"),
  nexusTokenPatten2: require("../asset/images/nexus/nexusTokenPatten2.png"),
  nexusTokenPatten3: require("../asset/images/nexus/nexusTokenPatten3.png"),
  nexusTokenPatten4: require("../asset/images/nexus/nexusTokenPatten4.png"),
  nexusTokenPatten5: require("../asset/images/nexus/nexusTokenPatten5.png"),
  nexusTokenPatten6: require("../asset/images/nexus/nexusTokenPatten6.png"),
  nexusTokenPatten7: require("../asset/images/nexus/nexusTokenPatten7.png"),
  nexusTokenPatten8: require("../asset/images/nexus/nexusTokenPatten8.png"),
  nexusTokenPatten9: require("../asset/images/nexus/nexusTokenPatten9.png"),

  // lunchpad Patten
  launchpadPatten1: require("../asset/images/nexus/launchpadPatten1.png"),
  launchpadPatten2: require("../asset/images/nexus/launchpadPatten2.png"),
  launchpadPatten3: require("../asset/images/nexus/launchpadPatten3.png"),
  launchpadPatten4: require("../asset/images/nexus/launchpadPatten4.png"),
  launchpadPatten5: require("../asset/images/nexus/launchpadPatten5.png"),
  launchpadPatten6: require("../asset/images/nexus/launchpadPatten6.png"),
  launchpadPatten7: require("../asset/images/nexus/launchpadPatten7.png"),
  launchpadPatten8: require("../asset/images/nexus/launchpadPatten8.png"),
  launchpadPatten9: require("../asset/images/nexus/launchpadPatten9.png"),
  launchpadPatten10: require("../asset/images/nexus/launchpadPatten10.png"),
  launchpadPatten11: require("../asset/images/nexus/launchpadPatten11.png"),
  launchpadPatten12: require("../asset/images/nexus/launchpadPatten12.png"),
  launchpadPatten13: require("../asset/images/nexus/launchpadPatten13.png"),
  launchpadPatten14: require("../asset/images/nexus/launchpadPatten14.png"),
  launchpadPatten15: require("../asset/images/nexus/launchpadPatten15.png"),
  launchpadPatten16: require("../asset/images/nexus/launchpadPatten16.png"),
  launchpadPatten17: require("../asset/images/nexus/launchpadPatten17.png"),
  launchpadPatten18: require("../asset/images/nexus/launchpadPatten18.png"),
  launchpadPatten19: require("../asset/images/nexus/launchpadPatten19.png"),
  launchpadPatten20: require("../asset/images/nexus/launchpadPatten20.png"),
  launchpadPatten21: require("../asset/images/nexus/launchpadPatten21.png"),
  launchpadPatten22: require("../asset/images/nexus/launchpadPatten22.png"),

  // nexus admin
  admin_logoImg: require("../asset/images/nexus/footerDarkThemeNexusLogo.png"),
}

